module.exports = __webpack_public_path__ + "img/reincarnated head of hieda.60f5edb8.png";